import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {CountryAutocompleteControl, BaseControl, SelectControl} from '../../../app/shared/classes';

export const DocumentTypeSelector = 'documentType';
export const DocumentNumberSelector = 'documentNumber';
export const ExpirationDateSelector = 'expirationDate';
export const CitizenshipSelector = 'citizenship';
export const TaxCountrySelector = 'taxCountry';
export const TaxNumberSelector = 'taxNumber';

export const PassportsEditFormControls = (): BaseControl<string | number>[] => {
    return [
        new SelectControl({
            name: DocumentTypeSelector,
            value: null,
            placeholder: 'ID document type',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        new BaseControl({
            name: DocumentNumberSelector,
            value: '',
            placeholder: 'ID document number',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text
        }),
        new BaseControl({
            name: ExpirationDateSelector,
            value: '',
            placeholder: 'Expiration date',
            validators: [],
            componentType: ComponentTypesEnum.LockableDatepicker,
            disabled: false,
            more: {
                texts: ['', 'Non-expiring document']
            }
        }),
    ];
};

export const CitizenshipsFormControl = (): BaseControl<number | string> => {
    return new CountryAutocompleteControl({
        name: CitizenshipSelector,
        value: null,
        placeholder: 'Citizenship',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.CountryAutocomplete,
        options: [],
        countries: [],
        removable: false
    });
};

export const TaxCountryFormControls = (): BaseControl<number | string>[] => {
    return [
        new CountryAutocompleteControl({
            name: TaxCountrySelector,
            value: null,
            placeholder: 'Tax country',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.CountryAutocomplete,
            options: [],
            countries: [],
            removable: false
        }),
        new BaseControl({
            name: TaxNumberSelector,
            value: '',
            placeholder: 'Tax number',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
            removable: false
        }),
    ];
};
